<ng-template #spinner>
  <ion-content style="margin: auto">
    <ion-row class="ion-justify-content-center ion-align-items-center" style="height: 25%">
      <ion-spinner></ion-spinner>
    </ion-row>
  </ion-content>
</ng-template>

<ng-container *ngIf="order; else spinner">
  <div class="container flex h-full flex-col">
    <div class="header flex w-full flex-row items-center justify-between">
      <div class="title flex w-full flex-row items-center">
        <ng-container *ngIf="order; else spinner">
          <div class="container flex h-full flex-col">
            <div class="header flex w-full flex-row items-center justify-between">
              <div class="title flex flex-row items-center">
                <ion-icon src="../../../assets/icon/paragraphs-bullets.svg"></ion-icon>
                <h1>Detalles de tu pedido</h1>
              </div>

              <ion-button fill="clear" class="close-button" (click)="onCloseModal()">
                <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
              </ion-button>
            </div>

            <hr />

            <div class="order-detail-container flex flex-col">
              <div *ngIf="trackingData" class="tracking-container">
                <app-client-tracking-data
                  [trackingData]="trackingData"
                  [showTrackingLink]="false"
                  [order]="order"
                  class="w-full"
                ></app-client-tracking-data>
              </div>

              <hr *ngIf="trackingData" />

              <h2>Tus artículos</h2>

              <div *ngIf="printGroupItems(order.cart?.items).length" class="products-list flex flex-col">
                <span> Tus carpetas de impresiones: </span>

                <div class="flex flex-row flex-wrap items-start gap-2.5">
                  <ng-container *ngFor="let item of printGroupItems(order.cart?.items); let i = index" class="w-full">
                    <app-print-group-folder-item [group]="item" [inOrderDetail]="true"></app-print-group-folder-item>
                  </ng-container>
                </div>
              </div>

              <div *ngIf="existStationeryProducts(order.cart?.items)" class="products-list flex flex-col">
                <span>Tus productos de papelería:</span>
                <div class="flex flex-col">
                  <ng-container *ngFor="let item of order.cart.items; let i = index" class="w-full">
                    <div class="flex flex-col items-center gap-5" *ngIf="item.product.type !== productType.PRINT">
                      <app-item-shop-product
                        class="w-full"
                        [item]="item"
                        [disableActions]="true"
                        [showQty]="true"
                      ></app-item-shop-product>
                    </div>
                  </ng-container>
                </div>
              </div>

              @if (order.shippingAddress) {
                <h2>Enviado a:</h2>

                <div class="shipping-info flex flex-col">
                  <span> {{ order.shippingAddress.recipient }} </span>
                  <span> {{ order.shippingAddress.addressLine1 }} </span>
                  <span>
                    {{ order.shippingAddress.postalCode }}, {{ order.shippingAddress.city }} ,
                    {{ order.shippingAddress.province }}
                  </span>
                </div>

                <div class="w-fit">
                  <div class="type-label" [ngClass]="order.shippingType">
                    <ion-icon [src]="shippingTypeLabel[order.shippingType].svg"></ion-icon>
                    <span
                      >ENVÍO <span>{{ shippingTypeLabel[order.shippingType].text }}</span></span
                    >
                  </div>
                </div>
              }

              <h2 *ngIf="order.paymentType">Método de pago:</h2>

              <div *ngIf="order.paymentType" class="w-fit">
                <div class="type-label payment-type">
                  <ion-icon [src]="paymentLabel[order.paymentType]?.svg"></ion-icon>
                  <span>{{ paymentLabel[order.paymentType]?.text }}</span>
                </div>
              </div>
              <ng-template #pendingPayment>
                <span class="box-status w-fit">Pago pendiente</span>
              </ng-template>

              <h2>Gastos:</h2>

              <div class="container flex flex-col">
                <div class="flex flex-row items-center justify-between">
                  <span class="text-lg font-medium">Gastos de envío</span>
                  <div class="flex flex-row items-center gap-2.5 text-lg font-medium" style="color: #949494">
                    <span>{{ order.cart.shipping.price.amt | currency: order.cart.shipping.price.cur }}</span>
                  </div>
                </div>

                <div class="flex flex-row items-center justify-between gap-11" *ngIf="order.cart.discounts.length">
                  <ng-container *ngFor="let discount of order.cart.discounts">
                    <ng-container [ngSwitch]="discount.type">
                      <div *ngSwitchCase="discountType.COUPON" class="flex flex-col gap-0.5">
                        <span class="text-lg font-medium !leading-none">
                          {{ discount.refId }}
                        </span>
                        <span class="coupon-description text-lg font-normal !leading-none">
                          {{ coupon?.title }}
                        </span>
                      </div>
                      <span *ngSwitchCase="discountType.WALLET" class="text-lg font-medium !leading-none">
                        BONO MONEDERO
                      </span>
                      <title *ngSwitchDefault>Descuento:</title>
                    </ng-container>
                    <span class="discount">
                      {{ discount.amount | currency: discount.currency }}
                    </span>
                  </ng-container>
                </div>

                <div class="flex flex-row justify-between">
                  <div class="flex flex-col">
                    <span class="text-lg font-medium">Subtotal</span>
                    <span class="text-lg font-normal" style="color: #949494">(IVA incluido)</span>
                  </div>

                  <div class="flex flex-col items-end">
                    <span class="text-lg font-medium" style="color: #949494" *ngIf="coupon && !isOnlyFreeShipping()">
                      Antes:
                      <span class="line-through">
                        {{ getBasePrice() | currency: order.cart.shipping.price.cur }}
                      </span>
                    </span>
                    <span class="text-lg font-medium">
                      <span *ngIf="coupon && !isOnlyFreeShipping()">Ahora: </span>
                      {{
                        coupon
                          ? (keepMinZero(getAfterPrice()) | currency: order.cart.shipping.price.cur)
                          : (keepMinZero(getBasePrice()) | currency: order.cart.shipping.price.cur)
                      }}
                    </span>
                  </div>
                </div>

                <div class="flex flex-row justify-between">
                  <div class="flex flex-col gap-2.5">
                    <div class="flex flex-row items-end gap-4">
                      <ion-text class="text-2xl font-semibold sm:text-3xl">TOTAL</ion-text>
                      <ion-text class="text-lg font-medium sm:text-xl" style="color: #949494">(IVA incluido)</ion-text>
                    </div>
                  </div>

                  <ion-text class="text-xl font-semibold sm:text-3xl">
                    {{ order.cart.price.totalAmt | currency: order.cart.price.cur }}
                  </ion-text>
                </div>
              </div>

              <hr />

              <div *ngIf="order.invoiceUrl" class="flex justify-end">
                <ion-button
                  fill="outline"
                  color="dark"
                  class="invoice-download flex flex-row items-center gap-2.5"
                  (click)="onDownloadInvoice()"
                >
                  <ion-icon src="../../../assets/icon/download-icon.svg"></ion-icon>
                  <span>Descargar factura</span>
                </ion-button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
